import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: "flights_apex_web_fare_included_copy_blackout",
    defaultStage: 1,
    stages: {
        solo_traveller_on_sr_or_bf_page: 1,
        search_results_page: 2,
        branded_fares_page: 3,
        desktop: 4,
        mdot: 5
    },
    goals: {},
    goalsWithValue: []
});
const trackStages = (props) => {
    if (props.isSearchResultsPage || props.isBrandedFaresPage) {
        utils.stages.solo_traveller_on_sr_or_bf_page();
        if (props.isSearchResultsPage) {
            utils.stages.search_results_page();
        }
        if (props.isBrandedFaresPage) {
            utils.stages.branded_fares_page();
        }
        if (props.isMobile) {
            utils.stages.mdot();
        }
        if (!props.isMobile) {
            utils.stages.desktop();
        }
    }
};
export default { ...utils, trackStages };
